<div *ngIf="isLoading()" class="loader">
  <div class="d-flex align-items-center justify-content-center h-100">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
